<template>
  <ProSpaceModal
    :key="`user-profile-modal-${localModelValue}`"
    v-model="localModelValue"
    :class="{ 'userprofile-modal--reset-password': showChangePassword }"
    :title="$t('userProfile')"
    :cancelTxt="$t('cancelTxt')"
    :applyTxt="$t('applyTxt')"
    :icon="icon"
    :width="600"
    :height="400"
    class="userprofile-modal"
    with-grey-background
    small-padding
    :validate-local="$t"
    :validate-model="password"
    :validate-config="{
      newPassword: {
        length: {
          message: $t('notValidPasswordLength'),
          fn: validatePasswordLength,
        },
        alph: {
          message: $t('notValidPasswordAlpth'),
          fn: validatePasswordAlpth,
        },
        alphUpper: {
          message: $t('notValidPasswordAlpthUpper'),
          fn: validatePasswordAlpthUpper,
        },
        numbers: {
          message: $t('validatePasswordNumbers'),
          fn: validatePasswordNumbers,
        },
        symbols: {
          message: $t('validatePasswordSymbols'),
          fn: validatePasswordSymbols,
        },
        userId: {
          message: $t('validatePasswordUserId'),
          fn: validatePasswordUserId,
        },
        userLogin: {
          message: $t('validatePasswordUserLogin'),
          fn: validatePasswordUserLogin,
        },
        userEmail: {
          message: $t('validatePasswordUserEmail'),
          fn: validatePasswordUserEmail,
        },
        userFirstName: {
          message: $t('validatePasswordUserFirstName'),
          fn: validatePasswordUserFirstName,
        },
        userLastName: {
          message: $t('validatePasswordUserLastName'),
          fn: validatePasswordUserLastName,
        },
        userSecondName: {
          message: $t('validatePasswordUserSecondName'),
          fn: validatePasswordUserSecondName,
        },
        space: {
          message: $t('validatePasswordSpace'),
          fn: validatePasswordSpace,
        },
        maap: {
          message: $t('validatePasswordMAAP'),
          fn: validatePasswordMAAP,
        },
        english: {
          message: $t('validatePasswordEnglish'),
          fn: validatePasswordEnglish,
        },
      },
    }"
    @apply="save"
    :needHideApply="false"
  >
    <template v-slot:default="{ v }">
      <ProSpaceVLayout :gap="10">
        <div class="userprofile-modal__block prospace-scrollbar" style="min-height: 144px; overflow: auto">
          <ProSpaceSidebarFooter
            :user="user"
            :current-locale="currentLocale"
            :locale-options="localeOptions"
            theme-txt=""
            language-txt=""
            @clear-storage="handlerClearStorage"
            :logout-txt="$t('sideBarLogoutTxt')"
            :storage-txt="$t('sideBarStorageTxt')"
            @changeLocale="changeLocale"
            @logout="logout"
            :is-row="true"
          >
            <template #roledropdown>
              <ProSpaceDropdown
                v-model="selectRoleModel"
                getMethod="getCurrentTranslated"
                :service="userRoleService"
                :label="$t('role')"
                :placeholder="$t('role')"
                class="dropdown__select-role"
              />
            </template>
            <ProSpaceVLayout :gap="5">
              <ProSpaceHLayout :gap="5" style="height: 18px">
                <ProSpaceTag
                  type="gray-light"
                  :text="user.id"
                  bordered
                  style="height: 18px"
                />
              </ProSpaceHLayout>
              <div class="text-bold text-color-main text-size-14">
                {{ user.name }}
              </div>
            </ProSpaceVLayout>
          </ProSpaceSidebarFooter>
        </div>
        <ProSpaceGeoLayout class="userprofile-modal__block">
          <template #center>
            <ProSpaceVLayout style="padding: 20px;">
              <ProSpaceVLayout
                v-if="showChangePassword"
                class="userprofile-modal__block-section"
              >
                <ProSpaceTextBlock
                  :top="$t('Password')"
                  :gap="10"
                  type="third"
                  break-word
                />
                <ProSpaceHLayout
                  :gap="10"
                  :align-items="isPasswordEdit ? 'flex-start' : 'flex-end'"
                  style="margin-top: 10px"
                >
                  <ProSpaceInputText
                    style="width: 50%"
                    :isPassword="true"
                    v-model="password.oldPassword"
                    :label="$t('currentPassword')"
                  ></ProSpaceInputText>
                  <ProSpaceAction
                    v-if="isPasswordEdit === false"
                    :text="$t('change')"
                    class="userprofile-modal__block--changepassword"
                    @click="isPasswordEdit = true"
                  ></ProSpaceAction>
                  <ProSpaceInputText
                    style="width: 50%"
                    :isPassword="true"
                    v-if="isPasswordEdit === true"
                    :label="$t('newPassword')"
                    v-model="password.newPassword"
                    :invalid="v.newPassword.$error"
                    :invalid-messages="v.newPassword.$errors"
                    @blur="v.newPassword.$touch"
                  ></ProSpaceInputText>
                </ProSpaceHLayout>
              </ProSpaceVLayout>
              <ProSpaceDivider v-if="showChangePassword" type="dashed" style="margin-top: 20px; margin-bottom: 20px;" />
              <ProSpaceVLayout class="userprofile-modal__block-section userprofile-modal__block-dates">
                <ProSpaceTextBlock
                  :top="$t('dateTimeFormat')"
                  :gap="10"
                  type="third"
                  break-word
                />
                <ProSpaceHLayout :gap="10" style="margin-top: 10px">
                  <ProSpaceDropdown
                    :label="$t('dateFormat')"
                    v-model="datetimeFormats.dateFormat"
                    getMethod="getDateFormats"
                    :service="dateHelperService"
                  ></ProSpaceDropdown>
                  <ProSpaceDropdown
                    :label="$t('timeZone')"
                    v-model="datetimeFormats.timeZoneId"
                    getMethod="getTimeZone"
                    :service="dateHelperService"
                  ></ProSpaceDropdown>
                  <ProSpaceDropdown
                    :label="$t('timeFormat')"
                    v-model="datetimeFormats.timeFormat"
                    getMethod="getTimeFormats"
                    :service="dateHelperService"
                  ></ProSpaceDropdown>
                </ProSpaceHLayout>
              </ProSpaceVLayout>
            </ProSpaceVLayout>
          </template>
        </ProSpaceGeoLayout>
      </ProSpaceVLayout>
    </template>
  </ProSpaceModal>
</template>

<script>
import accessMixin from "../../../Common/utils/elementAccess/accessMixin";
import {
  ProSpaceAction,
  ProSpaceDropdown,
  ProSpaceHLayout,
  ProSpaceTextBlock,
  ProSpaceInputText,
  ProSpaceModal,
  ProSpaceSidebarFooter,
  ProSpaceTag,
  ProSpaceVLayout,
  ProSpaceGeoLayout,
  ProSpaceDivider,
} from "@prospace/prospace-components-library";
import { UserService } from "../../../../Services/SecurityAdmin/ProSpace.SecurityAdmin.Frontend/services/UserService";
import { UserRoleService } from "../../../../Services/SecurityAdmin/ProSpace.SecurityAdmin.Frontend/services/UserRoleService";
import { DateHelperService } from "../../../../Services/SecurityAdmin/ProSpace.SecurityAdmin.Frontend/services/DateHelperService";
import { hashPassword } from "../../../Common/utils/passwordHelper";
import { mapGetters } from "vuex";
export default {
  mixins: [accessMixin],
  name: "UserProfileModal",
  components: {
    ProSpaceModal,
    ProSpaceHLayout,
    ProSpaceVLayout,
    ProSpaceTextBlock,
    ProSpaceInputText,
    ProSpaceAction,
    ProSpaceDropdown,
    ProSpaceSidebarFooter,
    ProSpaceTag,
    ProSpaceGeoLayout,
    ProSpaceDivider,
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    confirmTimezone: {
      type: [Boolean, Object],
      default: false
    },
    userInfo: {
      type: Object,
      default: null
    }
  },
  watch: {
    modelValue(val) {
      if (!val) {
        this.password.oldPassword = "";
        this.password.newPassword = "";
        this.isPasswordEdit = false;
      } else if (this.userInfo?.user) {
        this.datetimeFormats.dateFormat = this.userInfo.user.dateFormat;
        this.datetimeFormats.timeFormat = this.userInfo.user.timeFormat;
        this.datetimeFormats.timeZoneId = this.userInfo.user.timeZoneId;
      }
      this.$emit("update:modelValue", val);
    },
    async confirmTimezone(val) {
      if (val && typeof val !== 'object') {
        this.isTimezoneEdit = true;
        await this.save();
        this.logout();
      } else if (typeof val === 'object') {
        this.isTimezoneEdit = false;
        this.datetimeFormats.timeZoneId = this.user.timeZoneId;
      }
    },
    userInfo: {
      handler: function(val) {
        if (val) {
          const { user, currentLocale, localeOptions } = val;
          this.user = user;
          this.selectRoleModel = user?.role?.id;
          this.currentLocale = currentLocale;
          this.localeOptions = localeOptions;

          if (user) {
            this.datetimeFormats.dateFormat = user.dateFormat;
            this.datetimeFormats.timeFormat = user.timeFormat;
            this.datetimeFormats.timeZoneId = user.timeZoneId;
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      model: null,
      userService: new UserService(),
      userRoleService: new UserRoleService(),
      dateHelperService: new DateHelperService(),
      user: {},
      lightTheme: "light",
      darkTheme: "dark",
      currentThemeName: null,
      currentLocale: "",
      expandedLang: false,
      localeOptions: [],
      password: {
        oldPassword: "",
        newPassword: "",
      },
      isPasswordEdit: false,
      selectRoleModel: null,
      datetimeFormats: {
        dateFormat: "DD.MM.YYYY",
        timeFormat: "hh:mm:ss",
        timeZoneId: "Greenwich Standard Time",
      },
      isTimezoneEdit: false,
    };
  },
  created() {
    // const userRole = JSON.parse(localStorage.getItem("userRole"));
    // this.selectRoleModel = userRole ? userRole.id : null;
    const localeTheme = localStorage.getItem("theme");
    if (localeTheme) {
      this.currentThemeName = localeTheme;
    } else {
      this.currentThemeName = this.lightTheme;
    }
    //document.documentElement.setAttribute("data-theme", this.currentThemeName);
  },
  mounted() {
    this.loadLocalRoleAccess("userprofilemodal");
    console.log('UserInfo:',this.userInfo)
    console.log('User:',this.user)
  },
  methods: {
    validatePasswordLength(password) {
      if (this.isPasswordEdit) {
        return password.length >= 12;
      }
      return true;
    },
    validatePasswordAlpth(password) {
      if (this.isPasswordEdit) {
        let re = new RegExp("(?=.*[a-z])");
        return !(password.match(re) === null);
      }
      return true;
    },
    validatePasswordAlpthUpper(password) {
      if (this.isPasswordEdit) {
        let re = new RegExp("(?=.*[A-Z])");
        return !(password.match(re) === null);
      }
      return true;
    },
    validatePasswordNumbers(password) {
      if (this.isPasswordEdit) {
        let re = new RegExp("(?=.*\\d)");
        return !(password.match(re) === null);
      }
      return true;
    },
    validatePasswordSymbols(password) {
      if (this.isPasswordEdit) {
        let re = new RegExp("(?=.*[!*@#$%^&+=])");
        return !(password.match(re) === null);
      }
      return true;
    },
    validatePasswordUserId(password) {
      if (this.isPasswordEdit) {
        return !password.includes(this.user.id);
      }
      return true;
    },
    validatePasswordUserLogin(password) {
      if (this.isPasswordEdit && this.user.login) {
        return !password.toLowerCase().includes(this.user.login.toLowerCase());
      }
      return true;
    },
    validatePasswordUserEmail(password) {
      if (this.isPasswordEdit && this.user.email) {
        return !password.toLowerCase().includes(this.user.email.toLowerCase());
      }
      return true;
    },
    validatePasswordUserFirstName(password) {
      if (this.isPasswordEdit && this.user.firstName) {
        return !password
          .toLowerCase()
          .includes(this.user.firstName.toLowerCase());
      }
      return true;
    },
    validatePasswordUserLastName(password) {
      if (this.isPasswordEdit && this.user.lastName) {
        return !password
          .toLowerCase()
          .includes(this.user.lastName.toLowerCase());
      }
      return true;
    },
    validatePasswordUserSecondName(password) {
      if (this.isPasswordEdit && this.user.secondName) {
        return !password
          .toLowerCase()
          .includes(this.user.secondName.toLowerCase());
      }
      return true;
    },
    validatePasswordSpace(password) {
      if (this.isPasswordEdit) {
        return !password.includes(" ");
      }
      return true;
    },
    validatePasswordMAAP(password) {
      if (this.isPasswordEdit) {
        return !password.toLowerCase().includes("maap");
      }
      return true;
    },
    validatePasswordEnglish(password) {
      if (this.isPasswordEdit) {
        let re = new RegExp(/^.*(^[A-Za-z\s'&\d!*@#$%^&+=]*$).*$/);
        return !(password.match(re) === null);
      }
      return true;
    },
    async save() {
      let passwordResponse = null;
      if (this.isPasswordEdit) {
        passwordResponse = await this.changePassword();
        this.password.oldPassword = null;
        this.password.newPassword = null;
        this.isPasswordEdit = false;
      }
      if (passwordResponse && passwordResponse.data === false) return;
      let isRoleChanged =
      this.selectRoleModel != JSON.parse(localStorage.getItem("userRole")).id;
      if (isRoleChanged) {
        await this.userService
        .setCurrentRole({roleId:this.selectRoleModel})
        .then((res) => {
            if (res && res.data) {
              localStorage.setItem("userRole", JSON.stringify(res.data));
            }})
      }
      localStorage.setItem("dateFormat", this.datetimeFormats.dateFormat);

      let oldFormats = JSON.stringify({
        dateFormat: this.user.dateFormat,
        timeFormat: this.user.timeFormat,
        timeZoneId: this.user.timeZoneId,
      });
      let newFormats = JSON.stringify(this.datetimeFormats);
      if ((this.datetimeFormats.timeZoneId !== this.user.timeZoneId) && !this.isTimezoneEdit) {
        this.$emit("update:timezone");
        return;
      }
      if (newFormats !== oldFormats) {
        this.userService
          .updateDateTimeFormats(this.datetimeFormats)
          .then((res) => {
            if (res) {
              this.user.dateFormat = this.datetimeFormats.dateFormat;
              this.user.timeFormat = this.datetimeFormats.timeFormat;
              this.user.timeZoneId = this.datetimeFormats.timeZoneId;
              this.$store.dispatch("userinfoStore/setUserinfo", this.user);
            }
          });
      }
      this.$nextTick(() => {
        setTimeout(() => {
          if (isRoleChanged) {
            window.location.href = "/addressprogram/dashboard";
          } else {
            window.location.reload();
          }
        }, 1000);
      });
    },
    async changePassword() {
      var response = await this.userService.changePassword(
        hashPassword(this.password.oldPassword),
        hashPassword(this.password.newPassword)
      );
      return response;
    },
    changeTheme() {
      this.currentThemeName =
        this.currentThemeName === this.lightTheme
          ? this.darkTheme
          : this.lightTheme;
      document.documentElement.setAttribute(
        "data-theme",
        this.currentThemeName
      );
      localStorage.setItem("theme", this.currentThemeName);
    },
    changeLocale(locale) {
      this.$emit("changeLocale", locale);
    },
    logout() {
      this.$emit("logout");
    },
    handlerClearStorage() {
      this.$emit('clear-storage')
    }
  },
  computed: {
    ...mapGetters({
      access: "securityRoleAccess/access",
    }),
    icon() {
      return "user";
    },
    localModelValue: {
      get() {
        return this.modelValue;
      },
      set(newVal) {
        this.$emit("update:modelValue", newVal);
      },
    },
    langArrowIcon() {
      return this.expandedLang ? "arrow-up" : "arrow-down";
    },
    showChangePassword() {
      return this.user?.providerName === "Cookies";
    },
    getUserRolesOptions() {
      return this.user?.roles.map(role => {
        const translatedRole = this.$t((role.systemName).toLowerCase());
        return {
          ...role,
          translatedLabel: translatedRole
        }
      })
    }
  },
};
</script>
<style lang="scss">
.short-form-field {
  .form-field-inner {
    flex-direction: column;
  }
  .prospace-input-layout__label {
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
  }
}
</style>
<style lang="scss">
.userprofile-modal {
  .p-dialog-content {
    overflow: auto !important;
  }

  .prospace-modal__icon {
    .icon-user {
      width: 16px !important;
      height: 16px !important;
    }
  }

  &__block {
    &:not(.prospace-geo-layout) {
      padding: 20px;
    }
    &-section {
      width: 100%;
      .prospace-input-layout__label {
        font-weight: 400;
        font-size: 12px;
      }
    }
    &-dates {
      .prospace-text-block {
        height: auto;
        &__top {
          color: #687284;
        }
      }
      .prospace-input-layout__label {
        color: #687284;
        font-weight: 400;
        font-size: 12px;
      }
    }
    .prospace-input-layout.prospace-dropdown.dropdown__select-role {
      height: 50px;
      margin-top: 10px;
      .prospace-input-layout__label {
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 15px;
        color: var(--prospace-text-gray);
      }
      .p-dropdown.p-component {
        width: 200px;
        margin-right: 10px;
      }
    }

    .prospace-switch-theme {
      gap: 5px;
    }

    .prospace-switch-theme--dark.is-active {
      background: #fff !important;

      .prospace-switch-theme__icon {
        background-color: #cfd6e2 !important;
      }
    }
    .prospace-switch-theme--dark {
      background: inherit !important;

      .prospace-switch-theme__icon {
        background-color: #5b7692;
      }
    }

    .prospace-switch-theme--light {
      .prospace-switch-theme__icon {
        background-color: #b0bec5;
      }
    }

    .prospace-switch-theme--light.is-active {
      background-color: #2c3e50;

      .prospace-switch-theme__icon {
        background-color: #526b83 !important;
      }
    }
    &--changepassword {
      height: 30px;
    }
  }
  .prospace-sidebar-footer {
    &__controls {
      & > .prospace-h-layout {
        &:first-child {
          flex-direction: column-reverse !important;
        }
      }
    }
    &__info {
      .prospace-avatar {
        &__icon {
          width: 60px;
          height: 60px;
        }
      }
    }
    &--row {
      padding-left: 0;
    }
  }
}
</style>
<style lang="scss" scoped>
.userprofile-modal {
  z-index: 1000 !important;

  &__inner {
    width: 572px !important;
    height: 337px !important;
    .side-equal-block {
      width: calc(100% - 20px);
      padding-top: 10px;
    }
    .form-field {
      margin: 0;
    }
  }
  &--reset-password {
    .userprofile-modal__inner {
      height: 460px !important;
    }
  }
  &__block {
    width: 100%;
    background-color: var(--prospace-ui-card);
    box-shadow: 0 2px 10px rgba(51, 51, 51, 0.07);
    border-radius: 5px;
  }
}
</style>
